/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotifyService } from '../../services';

@Component({
    selector: 'app-page-error',
    templateUrl: './page-error.component.html',
    styleUrls: ['./page-error.component.scss']
})
export class PageErrorComponent implements OnInit, OnDestroy {
    constructor(private notifyService: NotifyService) {
    }

    ngOnInit() {
        this.notifyService.muteLocalNotifications();
    }

    ngOnDestroy() {
        this.notifyService.unmuteLocalNotifications();
    }
}
